import {TabsComponent} from "../../../styleguide/js/components/tabs/tabs";

window.pew.addRegistryEntry({key: 'wdf-tabs', domSelector: '.wdf-tabs', classDef: TabsComponent});


// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/includes/Components/Tabs/tabs-component.js